'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBookmark = function ActionBookmark(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
  );
};
ActionBookmark = (0, _pure2.default)(ActionBookmark);
ActionBookmark.displayName = 'ActionBookmark';
ActionBookmark.muiName = 'SvgIcon';

exports.default = ActionBookmark;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/bookmark.js
 ** module id = 1449
 ** module chunks = 0
 **/